import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { BoardVideo } from 'types';
import { setModal } from 'modules/_shared/redux/modalActions';
import VimeoVideoPlayer from 'modules/_shared/components/VimeoVideoPlayer';

type ViewVideoModalProps = {
  video: BoardVideo;
};

const ViewVideoModal: FC<ViewVideoModalProps> = ({ video }) => {
  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(setModal(null));
  };

  return (
    <>
      <Modal.Header>
        <h5 className="modal-title">{video.title}</h5>
        <a className="close cursor-pointer" onClick={handleClose}>
          <em className="icon ni ni-cross" />
        </a>
      </Modal.Header>

      <Modal.Body>
        <style>
          {`
            .video-view-modal .video-responsive {
              min-height: 0 !important;
            }
          `}
        </style>
        <div className="card card-bordered p-0 overflow-hidden">
          <div className="video-view-modal">
            <VimeoVideoPlayer videoId={video.videoId} />
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default ViewVideoModal;
